"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlledDateRangePicker = exports.ControlledDatePicker = void 0;
var react_1 = __importStar(require("react"));
var DatePicker_1 = require("./DatePicker");
var DateRangePicker_1 = require("./DateRangePicker");
function ControlledDatePicker(_a) {
    var initialValue = _a.initialValue, props = __rest(_a, ["initialValue"]);
    var onChange = props.onChange;
    var _b = __read((0, react_1.useState)(initialValue || ''), 2), value = _b[0], setValue = _b[1];
    var onDateChange = (0, react_1.useCallback)(function (date) {
        setValue(date);
        return onChange === null || onChange === void 0 ? void 0 : onChange(date);
    }, [onChange]);
    return react_1.default.createElement(DatePicker_1.DatePicker, __assign({ value: value }, props, { onChange: onDateChange }));
}
exports.ControlledDatePicker = ControlledDatePicker;
function ControlledDateRangePicker(props) {
    var _a = props.dateFrom, initialValueFrom = _a.initialValue, dateFrom = __rest(_a, ["initialValue"]);
    var _b = props.dateTo, initialValueTo = _b.initialValue, dateTo = __rest(_b, ["initialValue"]);
    var _c = __read((0, react_1.useState)(initialValueFrom || ''), 2), valueFrom = _c[0], setValueFrom = _c[1];
    var _d = __read((0, react_1.useState)(initialValueTo || ''), 2), valueTo = _d[0], setValueTo = _d[1];
    var onDateFromChange = (0, react_1.useCallback)(function (date) {
        var _a;
        setValueFrom(date);
        return (_a = dateFrom.onChange) === null || _a === void 0 ? void 0 : _a.call(dateFrom, date);
    }, [dateFrom]);
    var onDateToChange = (0, react_1.useCallback)(function (date) {
        var _a;
        setValueTo(date);
        return (_a = dateTo.onChange) === null || _a === void 0 ? void 0 : _a.call(dateTo, date);
    }, [dateTo]);
    return (react_1.default.createElement(DateRangePicker_1.DateRangePicker, __assign({}, props, { dateFrom: __assign(__assign({}, dateFrom), { value: valueFrom, onChange: onDateFromChange }), dateTo: __assign(__assign({}, dateTo), { value: valueTo, onChange: onDateToChange }) })));
}
exports.ControlledDateRangePicker = ControlledDateRangePicker;
